module.exports = __webpack_public_path__ + "img/return-parcel-picked-up.2d4f0aed.svg";